import * as R from "remeda";
import type { InputCandidate } from "../../../types/candidate";
import { isValueExist } from "../../../services/isValueExist";
import { OperatorDescriptionKinds } from "../../../containers/AutomationForm/Forms/InputForm/FieldEditor/FieldEditorRow/containers/UpdateValueDropdown/constanst";

export const enhanceInputs = (inputs: InputCandidate[]): InputCandidate[] =>
  inputs.map((input) => {
    if (
      R.isNil(input.value) ||
      R.isNil(input.value.values[0]?.value.oneofKind)
    ) {
      return input;
    } else if (input.value.values[0]?.value.oneofKind === "reference") {
      return {
        ...input,
        isOpen:
          isValueExist(input) ||
          input.operatorConfig?.operator.oneofKind ===
            OperatorDescriptionKinds.CLEAR,
      };
    } else {
      return {
        ...input,
        isOpen:
          isValueExist(input) ||
          input.operatorConfig?.operator.oneofKind ===
            OperatorDescriptionKinds.CLEAR,
      };
    }
  });
